<div
    class="product-header"
    [ngClass]="{
        'bottom-border': shouldDisplayBorder(),
        'background-opacity': productPageFacade.isProductPageRevampEnabled
    }">
    <h1 class="product-title-container">
        @if (product.displayNameList) {
        <span class="product-name-list">{{ product.displayNameList }}</span>
        <span class="sr-only">-</span>
        }
        <span class="product-title"> {{ product.title }} </span>
    </h1>
    @if (showPrice) {

    <p class="product-price paragraph-medium">
        <span [attr.aria-live]="'polite'" [attr.aria-atomic]="false">
            <h-price [price]="product.price" [size]="'medium'" [format]="'short'"> </h-price>
        </span>
        @if (product.unitPrice && product.unitPriceDesc) {
        <span class="product-unit-price"
            >(<h-price [price]="product.unitPrice" [size]="'small'" [format]="'short'"></h-price>
            {{ product.unitPriceDesc }})
        </span>
        }
    </p>
    @if (product.attributes.ecoTax) {
    <p class="product-eco-tax">
        <ng-container i18n="@@hermes.product-details.eco-tax">
            including a WEEE recycling fee of {{ ecoTax }}
        </ng-container>
    </p>
    } }
</div>
